import request from '../util/request'

// 登录方法
export function login(item) {
  const data = {
    username: item.username,
    password: item.password,
    code: item.code,
    uuid: item.uuid
  }
  return request({
    url: '/api/account/memberLogin',
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}

//合从权限
export function getMerchantCustomer(domainName) {
  return request({
    url: '/api/account/getMerchantCustomer',
    method: 'get',
    params:{domainName:domainName}
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js